import { inject, Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, of, switchMap, tap } from "rxjs";

import { NotificationService } from "../../_services/notification.service";
import { RequestActions } from "./index";
import { RequestService } from "./request.service";

@Injectable()
export class RequestEffects {
  private actions$ = inject(Actions);
  private requestService = inject(RequestService);
  private notificationService = inject(NotificationService);

  getRequests$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RequestActions.getRequests),
      // switchMap: only the latest query's response should win. With
      // mergeMap, rapid successive dispatches (e.g. editing two debounced
      // filters close together) can resolve out of order and let a stale
      // response overwrite the latest one.
      switchMap(query =>
        this.requestService.getRequestsByProductId(query).pipe(
          map(response => RequestActions.getRequestsSuccess(response)),
          catchError(() =>
            of(
              RequestActions.getRequestsFailure({
                regionName: query.region ?? "",
              })
            )
          )
        )
      )
    )
  );

  getRequestsFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(RequestActions.getRequestsFailure),
        tap(({ regionName }) => {
          const errorMessage = `Failed to load requests for region: ${regionName}.`;
          this.notificationService.showError(errorMessage);
        })
      ),
    { dispatch: false }
  );
}
